<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";
  import { _ } from "svelte-i18n";

  import PlanTabs from "./plan/PlanTabs.svelte";
  import WeekPlan from "./plan/WeekPlan.svelte";
  import MonthPlan from "./plan/MonthPlan.svelte";

  var selectedUser;
  let myAthletes = [];
  let athlete;

  const storedUser = localStorage.getItem("user");
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "(ditt navn)",
          surname: "",
        };

  if (window.location.search.replace("?", "") !== "") {
    selectedUser = window.location.search.replace("?", "");
  }

  function weekNumber(date) {
    var d = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  }

  function getMonday(d) {
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  function getSunday(d) {
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1) + 6; // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  const sessionsResult = useQuery("sessions", () =>
    user.id !== undefined
      ? selectedUser
        ? superagent
            .get("/api/sessions?athlete=" + selectedUser)
            .set("Authorization", "Bearer " + user.id)
            .then((response) => response.body)
        : superagent
            .get("/api/sessions")
            .set("Authorization", "Bearer " + user.id)
            .then((response) => response.body)
      : []
  );

  const daysResult = useQuery("days", () =>
    user.id !== undefined
      ? selectedUser
        ? superagent
            .get("/api/days?athlete=" + selectedUser)
            .set("Authorization", "Bearer " + user.id)
            .then((response) => response.body)
        : superagent
            .get("/api/days")
            .set("Authorization", "Bearer " + user.id)
            .then((response) => response.body)
      : []
  );

  function uniqueSessions(sessions) {
    return [...new Set(sessions.map((item) => item?.reference))]
      .map((entry) =>
        sessions
          .slice()
          .reverse()
          .find((item) => item?.reference === entry)
      )
      .filter((item) => item);
  }

  $: storedSessions = localStorage.getItem("sessions");
  $: sessions = uniqueSessions(
    selectedUser
      ? $sessionsResult.isLoading
        ? []
        : $sessionsResult.data
      : (storedSessions !== null ? JSON.parse(storedSessions) : []).concat(
          $sessionsResult.isLoading ? [] : $sessionsResult.data
        )
  );

  $: storedDays = localStorage.getItem("days");
  $: days = selectedUser
    ? $daysResult.isLoading
      ? []
      : $daysResult.data
    : (storedDays !== null ? JSON.parse(storedDays) : []).concat(
        $daysResult.isLoading ? [] : $daysResult.data
      );

  const athletes = useQuery("my-athletes", () =>
    user.id !== undefined
      ? superagent
          .get("/api/my-athletes")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => response.body)
      : []
  );

  $: if (!$athletes.isLoading && $athletes.data) {
    myAthletes = $athletes.data;
  }

  let currentTab = "week";

  let date = new Date();
  $: weekNo = weekNumber(date);
  $: startDate = getMonday(date);
  $: endDate = getSunday(date);
  $: daysInWeek = days.filter(
    (item) =>
      item !== undefined &&
      item.date >= startDate.toISOString().slice(0, 10) &&
      item.date <= endDate.toISOString().slice(0, 10)
  );
  $: weekSessions = sessions.filter(
    (item) =>
      item !== undefined &&
      item.date >= startDate.toISOString().slice(0, 10) &&
      item.date <= endDate.toISOString().slice(0, 10)
  );

  function changeFunc() {
    var selectBox = document.getElementById("athlete");
    var selectedValue = selectBox.options[selectBox.selectedIndex].value;

    if (selectedValue === "me") {
      selectedUser = null;
    } else {
      selectedUser = selectedValue;
    }
    $sessionsResult.refetch();
    $daysResult.refetch();
  }

  $: if (!$athletes.isLoading && $athletes.data) {
    athlete = $athletes.data.find((item) => item.id === selectedUser);
  }
</script>

<div class="content">
  <div style="min-height: 80.5px;">
    <div
      class="calendar-toolbar calendar-toolbar--trainer"
      style="transform: translateZ(0px);"
    >
      <div class="calendar-toolbar__athlete-choice">
        <label class="select select--secondary" for="athlete">
          <span class="select__button-secondary">
            <select
              value={selectedUser ?? "me"}
              id="athlete"
              on:change={changeFunc}
            >
              <option hidden="" disabled />
              <option value="me">{user.name} {user.surname}</option>
              {#each myAthletes as athlete}
                <option value={athlete.id}
                  >{athlete.name} {athlete.surname}</option
                >
              {/each}
            </select>
          </span>
        </label>
      </div>
      <div class="calendar-toolbar__season-add-new">
        <a
          on:click|preventDefault
          class="button-text button-text--add-season button-text--add"
          href="/planer/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/sesong/ny"
          >{$_("plans.add")}</a
        >
      </div>
      <PlanTabs bind:currentTab />
    </div>
  </div>
  <div class="layout">
    <div class="calendar">
      <div class="calendar__body">
        <div class="calendar__meta-info">
          <div class="layout-buttons layout-buttons--left-right">
            <button
              type="button"
              class="button-text button-text--season-name button-text--toggle"
              >{$_("plans.title")}</button
            >
            <div class="week-calendar-tools">
              <button
                type="button"
                class="button-text button-text--previous"
                on:click={() =>
                  (date = new Date(date.setDate(date.getDate() - 7)))}
                >{$_("plans.nav.lastWeek")}</button
              >
              <button
                type="button"
                class="button-text button-text--next"
                on:click={() =>
                  (date = new Date(date.setDate(date.getDate() + 7)))}
                >{$_("plans.nav.nextWeek")}</button
              >
              <div class="DayPicker-wrapper DayPicker-wrapper--inline">
                <button
                  type="button"
                  class="button-text button-text--calendar"
                  style="disabled:true">{$_("plans.nav.select")}</button
                >
              </div>
            </div>
          </div>
        </div>
        {#if currentTab === "week"}
          <WeekPlan
            {startDate}
            {endDate}
            {weekNo}
            {weekSessions}
            {daysInWeek}
            {athlete}
          />
        {:else}
          <div><MonthPlan {sessions} /></div>
        {/if}
      </div>
    </div>
  </div>
</div>
